import React from 'react';

import {
  SortieVehiculeRequestDto,
  SortieVehiculeViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import WrappedCheckbox from 'components/WrappedComponents/Form/FormFields/Checkbox/Checkbox';
import { useApi } from 'hooks/ApiStoreContext';
import { SortieVehicule } from 'types/SortieVehicule';
import { CSSUtils } from 'utils/CSSUtils';

import {
  generateSortieVehiculeRequestDtoFromSortieVehicule,
  validateSortieVehiculeRule,
} from '../../../utils';

interface VerificationPreSortieCheckboxProps {
  dossierId: string;
  codeML?: string | null;
  values: SortieVehicule;
}

export const VerificationPreSortieCodeMLCheckbox: React.FC<
  VerificationPreSortieCheckboxProps
> = ({
  dossierId,
  codeML,
  values,
}: VerificationPreSortieCheckboxProps): React.ReactElement => {
  const { GardienFourriereControllerApi: gfController } = useApi();
  const key: keyof SortieVehicule = 'isConfirmedCodeML';

  async function validator(value: string | undefined): Promise<void> {
    const sortieVehiculeRequestDto: SortieVehiculeRequestDto =
      generateSortieVehiculeRequestDtoFromSortieVehicule({
        ...values,
        [key]: value,
      });
    return await validateSortieVehiculeRule(
      dossierId,
      gfController,
      sortieVehiculeRequestDto,
      SortieVehiculeViolationDtoFormFieldEnum.CODE_ML_CORRECT,
    );
  }

  return (
    <WrappedCheckbox
      wrapperProps={{
        values,
        fieldKey: 'isConfirmedCodeML',
        itemProps: {
          label: codeML
            ? `Le code de la mainlevée est ML${codeML}`
            : "une erreur inattendue s'est produite, veuillez contacter l'administrateur",
          hasFeedback: true,
          labelCol: { span: CSSUtils.defaultLabelCol },
          rules: [
            {
              validator: async (
                _rule,
                value: string | undefined,
              ): Promise<void> => {
                return await validator(value);
              },
            },
          ],
        },
      }}
      checkboxProps={{
        name: 'isConfirmedCodeML',
      }}
    />
  );
};
